var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[(_vm.block)?_c('v-btn',{class:_vm.status,attrs:{"block":"","x-small":"","label":"","text":""}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(!_vm.block)?_c('v-btn',{class:_vm.status,attrs:{"x-small":"","label":"","text":""}},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }